'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCsaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-7.62939e-06 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 6.55651e-07 20C6.55651e-07 13.3333 5.40545e-05 6.66667 -7.62939e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-7.62939e-06 0H28V20H6.55651e-07L-7.62939e-06 0Z",
          fill: "#19BFBF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 16.041C10 16.0138 10.0033 15.9866 10.01 15.9602L11.3098 10.7608C11.3252 10.6993 11.3227 10.6347 11.3026 10.5746L10.7103 8.79765C10.6824 8.71378 10.6222 8.64445 10.5432 8.60492L9.5176 8.09213C9.40467 8.03567 9.33333 7.92025 9.33333 7.79399V5.41202C9.33333 5.36027 9.34538 5.30924 9.36853 5.26295L10.5745 2.85093C10.631 2.738 10.7464 2.66667 10.8727 2.66667H14.3333C14.5174 2.66667 14.6667 2.81591 14.6667 3V3.66667C14.6667 3.85076 14.8159 4 15 4H15.6667C15.8508 4 16 4.14924 16 4.33333V5.12732C16 5.25358 16.0713 5.369 16.1843 5.42546L18.4824 6.57454C18.5953 6.631 18.6667 6.74642 18.6667 6.87268V7.92131C18.6667 7.97306 18.6546 8.0241 18.6315 8.07038L18.0396 9.25416C18.0136 9.30604 17.9746 9.35026 17.9263 9.38244L16.0737 10.6176C16.0254 10.6497 15.9864 10.694 15.9604 10.7458L14.7063 13.2542C14.6803 13.306 14.6413 13.3503 14.593 13.3824L12.7403 14.6176C12.6921 14.6497 12.653 14.694 12.6271 14.7458L11.4255 17.1491C11.369 17.262 11.2536 17.3333 11.1273 17.3333H10.3333C10.1492 17.3333 10 17.1841 10 17V16.041Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagCsaAsset = forwardRef(FlagCsaAsset);

export { VpFlagCsaAsset as default };
